import React, { useMemo } from "react";
import { NavigationProp, RouteProp, useNavigation, useRoute } from "@react-navigation/native";

import type { RootStackParamList } from "../../navigation/navigation.types";
import CourseEvaluatorReviewContainer from "./courseModernizer/review/CourseEvaluatorReviewContainer";
import NoPermissionPanel from "./courseModernizer/review/components/NoPermissionPanel";
import { getCourseEvaluatorReviewMockData } from "./courseModernizer/review/mockData/courseEvaluatorReview.mockData";

function CourseEvaluatorReviewView() {
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const route = useRoute<RouteProp<RootStackParamList, "Course Modernizer Review">>();

  const queryCourseId =
    typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("courseId")?.trim() : undefined;
  const courseId = queryCourseId || route.params?.courseId?.trim() || undefined;

  // TODO: Replace with real ownership check via GraphQL query
  // e.g. useGetModernizedCourseQuery({ variables: { courseId } })
  // and check if the current user is the owner/faculty of this course
  const hasPermission = true;

  const handleGoBack = () => navigation.navigate("Course Modernizer");

  const reviewMock = useMemo(() => getCourseEvaluatorReviewMockData(courseId), [courseId]);

  if (!hasPermission) {
    return <NoPermissionPanel onGoBack={handleGoBack} />;
  }

  return <CourseEvaluatorReviewContainer review={reviewMock} onExitReview={handleGoBack} />;
}

export default CourseEvaluatorReviewView;
